import type { HelperAssignedItem } from '../../services/helper/helperAssignedItemsService'

export const formatHelperDueLabel = (
  item: Pick<HelperAssignedItem, 'scheduleEndDate' | 'scheduleStartDate'>,
  nowMs = Date.now(),
  locale?: string,
): string | null => {
  const iso = item.scheduleEndDate ?? item.scheduleStartDate
  if (!iso) return null
  const due = new Date(iso)
  if (Number.isNaN(due.getTime())) return null
  const delta = due.getTime() - nowMs
  const days = Math.round(delta / 86_400_000)
  if (Math.abs(days) <= 1) {
    return delta < 0 ? 'Overdue' : delta < 86_400_000 ? 'Today' : 'Tomorrow'
  }
  if (days < 0) return `${Math.abs(days)}d overdue`
  if (days < 7) return `in ${days}d`
  return due.toLocaleDateString(locale, { month: 'short', day: 'numeric' })
}
